import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'gl-site-footer',
  imports: [RouterLink],
  template: `
    <footer class="site-footer">
      <img
        class="footer-plant footer-plant-left"
        src="/images/footer/footer-left-plant.webp"
        width="720"
        height="522"
        loading="lazy"
        decoding="async"
        alt=""
        aria-hidden="true"
      >
      <img
        class="footer-plant footer-plant-right"
        src="/images/footer/footer-right-plant.webp"
        width="640"
        height="533"
        loading="lazy"
        decoding="async"
        alt=""
        aria-hidden="true"
      >

      <svg class="footer-wave" viewBox="0 0 1600 92" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 34C160 4 272 23 395 52c135 32 238 39 370 4 139-37 214-57 358-12 157 48 277 33 477-8v56H0Z"></path>
        <path d="M0 63c165-31 272-22 404 1 133 23 240 25 364 0 151-31 239-38 367-8 153 36 285 23 465-10v46H0Z"></path>
      </svg>

      <div class="footer-main">
        <div class="footer-grid">
          <section class="footer-brand" aria-label="Grih Upvan">
            <a class="footer-logo" routerLink="/" aria-label="Grih Upvan home">
              <span class="footer-logo-mark" aria-hidden="true">
                <svg viewBox="0 0 38 38">
                  <path d="M19 34V15"></path>
                  <path d="M18 18C8 17 5 10 7 3c8 1 13 7 11 15Z"></path>
                  <path d="M20 23c10-1 15-8 13-16-8 1-13 7-13 16Z"></path>
                  <path d="M18 29c-7 0-11-4-11-10 7 0 11 4 11 10Z"></path>
                </svg>
              </span>
              <span>Grih Upvan</span>
            </a>
            <p>Bringing nature closer to you.<br>Happy plants, happier life.</p>
            <!-- <nav class="footer-socials" aria-label="Grih Upvan social media">
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.7 21v-8h2.7l.4-3h-3.1V8.1c0-.9.3-1.5 1.6-1.5H17V3.9c-.8-.1-1.5-.2-2.3-.2-2.3 0-3.9 1.4-3.9 4V10H8.2v3h2.6v8h2.9Z"></path></svg>
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="5"></rect><circle cx="12" cy="12" r="3.5"></circle><circle class="fill-dot" cx="17.5" cy="6.7" r="1"></circle></svg>
              </a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.4 7.1a2.5 2.5 0 0 0-1.8-1.8C17 4.9 12 4.9 12 4.9s-5 0-6.6.4a2.5 2.5 0 0 0-1.8 1.8A26 26 0 0 0 3.2 12c0 1.7.1 3.3.4 4.9a2.5 2.5 0 0 0 1.8 1.8c1.6.4 6.6.4 6.6.4s5 0 6.6-.4a2.5 2.5 0 0 0 1.8-1.8c.3-1.6.4-3.2.4-4.9s-.1-3.3-.4-4.9Z"></path><path class="play" d="m10 9 5 3-5 3Z"></path></svg>
              </a>
              <a href="https://www.pinterest.com/" target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2a8.8 8.8 0 0 0-3.2 17c-.1-1.5 0-3.2.4-4.5l1.1-4.7s-.3-.6-.3-1.5c0-1.4.8-2.5 1.8-2.5.9 0 1.3.6 1.3 1.4 0 .9-.6 2.2-.9 3.4-.2 1 .5 1.8 1.5 1.8 1.8 0 3.1-1.9 3.1-4.6 0-2.4-1.7-4.1-4.2-4.1-2.9 0-4.6 2.2-4.6 4.4 0 .9.3 1.8.8 2.3.1.1.1.2.1.4l-.3 1.3c-.1.4-.4.5-.8.3-1.2-.6-2-2.4-2-3.9 0-3.2 2.3-6.1 6.7-6.1 3.5 0 6.2 2.5 6.2 5.8 0 3.5-2.2 6.3-5.2 6.3-1 0-2-.5-2.3-1.1l-.6 2.4c-.4 1.3-1 2.7-1.7 3.7A8.8 8.8 0 1 0 12 3.2Z"></path></svg>
              </a>
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 8.2H3.2V20h3.3V8.2ZM4.8 3A1.9 1.9 0 1 0 4.8 6.8 1.9 1.9 0 0 0 4.8 3ZM20.8 13.2c0-3.6-1.9-5.3-4.5-5.3-2.1 0-3 1.1-3.5 2V8.2H9.5V20h3.3v-5.8c0-1.5.3-3 2.2-3 1.9 0 1.9 1.8 1.9 3.1V20h3.3l.6-6.8Z"></path></svg>
              </a>
            </nav> -->
          </section>

          <nav class="footer-link-column" aria-labelledby="footer-shop-heading">
            <h2 id="footer-shop-heading">Shop</h2>
            <a routerLink="/products">All Products</a>
            <a routerLink="/products" [queryParams]="{ catalog: 'indoor-plants' }">Indoor Plants</a>
            <a routerLink="/products" [queryParams]="{ catalog: 'outdoor-plants' }">Outdoor Plants</a>
            <a routerLink="/products" [queryParams]="{ catalog: 'pots-planters' }">Pots &amp; Planters</a>
            <a routerLink="/products" [queryParams]="{ catalog: 'accessories' }">Accessories</a>
            <a routerLink="/products" [queryParams]="{ catalog: 'offers', sort: 'discount' }">Offers</a>
          </nav>

          <nav class="footer-link-column" aria-labelledby="footer-company-heading">
            <h2 id="footer-company-heading">Company</h2>
            <a routerLink="/about">About Us</a>
            <a routerLink="/contact">Contact Us</a>
            <a routerLink="/faq">FAQs</a>
          </nav>

          <nav class="footer-link-column" aria-labelledby="footer-help-heading">
            <h2 id="footer-help-heading">Help</h2>
            <a routerLink="/help">Help &amp; Support</a>
            <a routerLink="/returns">Returns</a>
            <a routerLink="/plant-care-guide">Plant Care Guide</a>
          </nav>

          <section class="footer-community" aria-labelledby="footer-community-heading">
            <div class="footer-community-copy">
              <span class="community-sprout" aria-hidden="true">
                <svg viewBox="0 0 42 42"><path d="M21 37V18"></path><path d="M20 23C9 22 5 14 7 6c9 1 14 8 13 17Z"></path><path d="M22 28c10-1 15-8 13-17-8 2-13 8-13 17Z"></path></svg>
              </span>
              <div>
                <h2 id="footer-community-heading">Join our green community</h2>
                <p>Tips, new arrivals and exclusive plant offers.</p>
              </div>
            </div>

            <form class="footer-subscribe" (submit)="subscribe($event)">
              <label class="sr-only" for="footer-newsletter-email">Email address</label>
              <span class="footer-email-field">
                <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="m4 7 8 6 8-6"></path></svg>
                <input id="footer-newsletter-email" name="email" type="email" autocomplete="email" placeholder="Enter your email" required>
              </span>
              <button type="submit">Subscribe <span aria-hidden="true">→</span></button>
            </form>

            <div class="footer-benefits" aria-label="Shopping benefits">
              <div class="footer-benefit">
                <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M3 8h16v14H3zM19 13h5l5 5v4H19z"></path><circle cx="9" cy="24" r="2.5"></circle><circle cx="24" cy="24" r="2.5"></circle><path d="M6 5h8"></path></svg>
                <span>Free<br>Delivery</span>
              </div>
              <div class="footer-benefit">
                <svg viewBox="0 0 32 32" aria-hidden="true"><path class="benefit-fill" d="M16 27C6 23 6 12 8 5c7 2 11 8 8 22Z"></path><path class="benefit-fill" d="M17 25c1-9 5-14 12-16 1 8-3 14-12 16Z"></path><path d="M16 27c-1-8-3-13-7-17M17 25c3-5 6-8 10-11"></path></svg>
                <span>72-Hour<br>Plant Returns</span>
              </div>
              <div class="footer-benefit">
                <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3c4 3 8 4 12 4v8c0 7-4.4 11.4-12 14-7.6-2.6-12-7-12-14V7c4 0 8-1 12-4Z"></path><path d="M16 9v13M12 16l4 4 5-6"></path></svg>
                <span>Secure<br>Payments</span>
              </div>
              <div class="footer-benefit">
                <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M5 17v-2a11 11 0 0 1 22 0v2"></path><path d="M7 16H5a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h2V16ZM25 16h2a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-2V16ZM25 25c-1 3-3 4-7 4"></path></svg>
                <span>Plant Care<br>Support</span>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2026 Grih Upvan. All rights reserved.</p>
        <nav class="footer-legal" aria-label="Legal">
          <a routerLink="/privacy">Privacy</a><span aria-hidden="true">|</span>
          <a routerLink="/terms">Terms</a><span aria-hidden="true">|</span>
          <a routerLink="/sitemap">Sitemap</a>
        </nav>
        <div class="footer-payments" aria-label="Accepted payment methods">
          <span class="payment-logo payment-visa" aria-label="Visa">VISA</span>
          <span class="payment-logo payment-mastercard" aria-label="Mastercard"><i></i><i></i></span>
          <span class="payment-logo payment-upi" aria-label="UPI"><b>UPI</b><i></i><i></i></span>
          <span class="payment-logo payment-paytm" aria-label="Paytm"><b>pay</b><b>tm</b></span>
          <span class="payment-logo payment-rupay" aria-label="RuPay"><b>RuPay</b><i></i></span>
        </div>
      </div>
    </footer>
  `,
})
export class SiteFooterComponent {
  subscribe(event: SubmitEvent) {
    event.preventDefault();
  }
}
